<!--
  * name: NewsCategory
  * description: [Main] 뉴스 컴포넌트 페이지
-->
<template>
  <div>
    <bread-crumb location="NEWS"></bread-crumb>
    <page-title class="mt-14 mb-18"><strong>botalab</strong> News</page-title>
    <news-list
      ref="newsList"
      :stored-page-data="storedPageData"
      :paging-data="pagingData"
      :news-list="newsList"
      :search-text="searchText"
      @move-to-detail="moveToDetail"
      @search-news="searchNews"
      :is-loaded="isLoaded"
    />
  </div>
</template>

<script>
import BreadCrumb from '@/components/breadcrumb/BreadCrumb.vue';
import PageTitle from '@/components/page/PageTitle.vue';
import { mapGetters } from 'vuex';
import newsApi from '@/apis/news';
import { log } from '@/utils/common';
import NewsList from './partial/NewsList.vue';

export default {
  name: 'News',
  components: {
    BreadCrumb,
    PageTitle,
    NewsList,
  },
  data() {
    return {
      searchText: '',
      newsList: [],
      pagingData: {
        pageSize: 9,
        rangeSize: 5,
        currentPage: 1,
        totalCount: 1,
      },
      isLoaded: false,
    };
  },
  computed: {
    ...mapGetters({
      storedPageData: 'page/getPageData',
    }),
  },
  watch: {
    // eslint-disable-next-line func-names
    'pagingData.currentPage': function () {
      this.getNewsList();
    },
    type() {
      this.searchText = '';
      this.pagingData.currentPage = 1;
      this.$refs.newsList.setSearchText(this.searchText);
      this.getNewsList();
    },
  },
  mounted() {
    this.initialize();
    this.getNewsList();
  },
  methods: {
    // ## 초기데이터 정보 조회
    initialize() {
      if (this.storedPageData && this.storedPageData.pageName === 'News') {
        this.$refs.newsList.setSearchText(this.storedPageData.params.searchText);
        this.searchText = this.storedPageData.params.searchText;
        this.pagingData.currentPage = this.storedPageData.params.currentPage;
      }
    },
    // ## 뉴스 리스트 조회
    // eslint-disable-next-line consistent-return
    async getNewsList() {
      this.newsList = [];
      this.isLoaded = false;
      const title = this.searchText === '' ? null : this.searchText;
      const newsData = await newsApi.getNewsList(
        title,
        this.pagingData.pageSize,
        this.pagingData.currentPage,
      );
      if (newsData.error) {
        log('newsApi::getNewsDetail', 'error', newsData);
        return newsData;
      }
      this.pagingData.totalCount = newsData.totalSize;
      this.newsList = newsData.list;
      this.isLoaded = true;
    },
    // ## 뉴스 디테일 페이지 이동
    moveToDetail(newsId) {
      this.$store.dispatch('page/set', {
        pageName: 'News',
        params: {
          currentPage: this.pagingData.currentPage,
          searchText: this.searchText,
        },
      });
      this.$router.push({
        name: 'NewsDetail',
        params: { newsId },
      });
    },
    // ## 검색 처리
    searchNews(searchText) {
      this.searchText = searchText;
      this.pagingData.currentPage = 1;
      this.getNewsList();
    },
  },
};
</script>
